<template>
  <div class="pd-horizontal-4">
    <div class="tit-h5">{{ t('credit_history') }}</div>
    <Tabs :tabs="listTab" :active-tab="tabActive" size="big" @tabClick="handleTabClick" />

    <template v-if="listCreditRecord.length > 0">
      <div class="day-datail-con pdb-8">
        <CreditHistory v-for="item in listCreditRecord" :key="item.paymentId" :invoice-detail="item" />
      </div>
      <ButtonGetMore v-if="hasMore" @get-more="getListCreditHistory(true)" />
    </template>

    <div v-else class="no-data pd-vertical-7 no-data-flex">
      <div class="icon-area">
        <img :src="getAssetImageUrl('app/status/no-data.svg')" alt="" />
      </div>
      <span>{{ t('no_records') }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { watchDeep } from '@vueuse/core';

import { fetchSelfServiceCreditDetail } from '@/api/apiService';
import CreditHistory from '@/components/domains/self-service/payment-settings/CreditHistory.vue';
import ButtonGetMore from '@/components/shared/base/ButtonGetMore.vue';
import Tabs from '@/components/shared/composite/Tabs.vue';
import { IResponsePaymentHistory } from '@/types/response';
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';

const { t } = useI18n();

const listCreditRecord = ref<IResponsePaymentHistory[]>([]); // 크래딧 내역 목록
const hasMore = ref<boolean>(false); // 크래딧 내역 테이블 더보기 버튼 노출 여부
const nextOffset = ref<string | null>(null); // 크래딧 내역 더보기 조회 기준점
const tabActive = ref(0); // 현재 바라보고 있는 탭

const listFilterSearch = ref([
  {
    label: 'ss_invoice_type_topup',
    value: 'CHARGE',
    isChecked: false,
  },
  {
    label: 'label_use',
    value: 'USAGE',
    isChecked: false,
  },
  {
    label: 'label_cancel',
    value: 'CANCEL',
    isChecked: false,
  },
]);

const listTab = computed(() => {
  return ['label_all', 'ss_invoice_type_topup', 'label_use', 'label_cancel'];
});

const getTypeString = (): string | null => {
  switch (tabActive.value) {
    case 1:
      return 'CHARGE';
    case 2:
      return 'USAGE';
    case 3:
      return 'CANCEL';
    default:
      return null;
  }
};

const getListCreditHistory = async (isGetMore = false) => {
  const {
    data = {
      datas: [],
      hasMore: false,
      nextOffset: false,
    },
  } = await fetchSelfServiceCreditDetail(nextOffset.value, getTypeString());

  if (isGetMore) {
    listCreditRecord.value.push(...data.datas);
  } else {
    listCreditRecord.value = data.datas;
  }

  hasMore.value = data.hasMore;
  nextOffset.value = data.nextOffset;
};

const handleTabClick = (index) => {
  if (tabActive.value === index) return;
  nextOffset.value = '';
  tabActive.value = index;
  getListCreditHistory();
};

onMounted(async () => {
  await getListCreditHistory();
});

watchDeep(
  () => listFilterSearch.value,
  async () => {
    await getListCreditHistory();
  }
);
</script>

<style scoped lang="scss">
.nd-tab-con {
  .pd-horizontal-4 {
    height: 100%;
  }
  .tit-h5 {
    padding: 2rem 0 0.75rem;
  }
}
.day-datail-con {
  overflow-y: auto;
  height: calc(100% - 200px);
  @include respond-to(mobile-landscape) {
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
